export default __webpack_public_path__ + "static/media/image10.6ad8b578.jpg";